import { render, staticRenderFns } from "./AboutSlide.vue?vue&type=template&id=3cf3ca48&scoped=true&"
import script from "./AboutSlide.vue?vue&type=script&lang=js&"
export * from "./AboutSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3ca48",
  null
  
)

export default component.exports